var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearch = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66659 2.66659C4.45745 2.66659 2.66659 4.45745 2.66659 6.66659C2.66659 8.87572 4.45745 10.6666 6.66659 10.6666C8.87572 10.6666 10.6666 8.87572 10.6666 6.66659C10.6666 4.45745 8.87572 2.66659 6.66659 2.66659ZM1.33325 6.66659C1.33325 3.72107 3.72107 1.33325 6.66659 1.33325C9.6121 1.33325 11.9999 3.72107 11.9999 6.66659C11.9999 7.89906 11.5819 9.03389 10.8798 9.93702L14.4713 13.5285C14.7317 13.7889 14.7317 14.211 14.4713 14.4713C14.211 14.7317 13.7889 14.7317 13.5285 14.4713L9.93702 10.8798C9.03389 11.5819 7.89906 11.9999 6.66659 11.9999C3.72107 11.9999 1.33325 9.6121 1.33325 6.66659Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "66590cbd5309fc58a2e471959615d720.svg";